import type { ToggleVideoGridAction } from './toggle-video-grid';
export type ActionT = ToggleVideoGridAction;
export const ACTION = {
  TOGGLE_VIDEO_GRID: 'TOGGLE_VIDEO_GRID'
};